import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeRectangleAreaIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapeRectangleArea" ref={ref} {...props}>
    <path d="M17,20.74H7A3.75,3.75,0,0,1,3.26,17V7A3.75,3.75,0,0,1,7,3.26H17A3.75,3.75,0,0,1,20.74,7V17A3.75,3.75,0,0,1,17,20.74ZM7,4.76A2.25,2.25,0,0,0,4.76,7V17A2.25,2.25,0,0,0,7,19.24H17A2.25,2.25,0,0,0,19.24,17V7A2.25,2.25,0,0,0,17,4.76ZM6,11.25a.75.75,0,1,0,.75.75A.76.76,0,0,0,6,11.25Zm3-3A.75.75,0,1,0,9.75,9,.76.76,0,0,0,9,8.25Zm3-3a.75.75,0,1,0,.75.75A.76.76,0,0,0,12,5.25Zm-3,9a.75.75,0,1,0,.75.75A.76.76,0,0,0,9,14.25Zm-3,3a.75.75,0,1,0,.75.75A.76.76,0,0,0,6,17.25Zm6-6a.75.75,0,1,0,.75.75A.76.76,0,0,0,12,11.25Zm3-3a.75.75,0,1,0,.75.75A.76.76,0,0,0,15,8.25Zm3-3a.75.75,0,1,0,.75.75A.76.76,0,0,0,18,5.25Zm-12,0A.75.75,0,1,0,6.75,6,.76.76,0,0,0,6,5.25Zm9,9a.75.75,0,1,0,.75.75A.76.76,0,0,0,15,14.25Zm-3,3a.75.75,0,1,0,.75.75A.76.76,0,0,0,12,17.25Zm6-6a.75.75,0,1,0,.75.75A.76.76,0,0,0,18,11.25Zm0,6a.75.75,0,1,0,.75.75A.76.76,0,0,0,18,17.25Z" />
  </Icon>
)) as IconWithRender;

ShapeRectangleAreaIcon.displayName = 'ShapeRectangleAreaIcon';
ShapeRectangleAreaIcon.renderIcon = (props) => (
  <ShapeRectangleAreaIcon {...props} />
);
export default ShapeRectangleAreaIcon;
